import { createAction, props } from '@ngrx/store';
import { ResponseTre, RequestTre } from '../../shared/interfaces';
import { TreTypes } from '../../shared/enums';


export const getTre = createAction(
    TreTypes.TRE,
    props<{ request: RequestTre}>()
);

export const getTreSucess = createAction(
    TreTypes.TRE_SUCCESS,
    props<{ response: ResponseTre }>()
);

export const getTreError = createAction(
    TreTypes.TRE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    TreTypes.CLEAN_STATE
);
